export const LENDERS_MOTHLY_INCOME_DEFAULT_VALUES = {
  income: {
    totalIncome: 0,
    primaryMonthlyIncome: NaN,
    primaryOtherMonthlyIncome: NaN,
    coApplicantMonthlyIncome: NaN,
    coApplicantOtherMonthlyIncome: NaN,
  },
};
